import 'bootstrap';
import '../css/app.scss';
import barba from '@barba/core';
import Scrollbar from 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js'
//import Parallax from 'jquery-parallax.js/parallax.min.js'
import Slick from 'slick-carousel/slick/slick.min.js'
//import FluidVids from 'fluidvids.js/dist/fluidvids.js'
import AutoComplete from 'devbridge-autocomplete/dist/jquery.autocomplete.min.js'
import Sitewide from './sitewide.js';

import Home from './pages/home';
import Work from './pages/work';
import WorkCategory from './pages/work_category';
import WorkEntry from './pages/work_entry';
import Holding from './pages/holding';
import About from './pages/about';
import TeamEntry from './pages/team';
import News from './pages/news';
import NewsEntry from './pages/news_entry';
import FurtherReading from './pages/further-reading';
import FurtherReadingEntry from './pages/further-reading_entry';
import Shop from './pages/shop';
import ShopEntry from './pages/shop_entry';
import Foundation from './pages/foundation';
import FoundationEntry from './pages/foundation_entry';
import Programmes from './pages/programmes';
import ProgrammesEntry from './pages/programmes_entry';
import Contact from './pages/contact';
import ContactZoho from './pages/contact_zoho';
import Privacy from './pages/privacy';
import TermsOfUse from './pages/terms_of_use';
import Manifesto from './pages/manifesto';

barba.init({
	timeout: 10000,
	/*transitions: [{
		name: 'opacity-transition',
		leave(data) {
		  return gsap.to(data.current.container, {
			opacity: 0
		  });
		},
		enter(data) {
		  return gsap.from(data.next.container, {
			opacity: 0
		  });
		}
	  }],*/
	views: [Home,Work,WorkCategory,WorkEntry,Holding,About,TeamEntry,News,NewsEntry,FurtherReading,FurtherReadingEntry,Shop,ShopEntry,Foundation,FoundationEntry,Programmes,ProgrammesEntry,Contact,ContactZoho,Privacy,TermsOfUse,Manifesto],
});

import { closeModals } from './sitewide.js';
import { blazyInit } from './sitewide.js';
import { hashScrollInit } from './sitewide.js';
//import { tabsInit } from './sitewide.js';

barba.hooks.enter(({ current, next }) => {
	current.container.remove();
});

barba.hooks.afterEnter((data) => {
	closeModals();
	hashScrollInit();
	setTimeout(function(){
		blazyInit();
	}, 200);
});
